






























import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from './store/store';
import * as signalR from '@aspnet/signalr';

import Navmenu from '@/components/NavMenu.vue';
import Header from '@/components/Header.vue';
Vue.component('menu-component', Navmenu);
Vue.component('header-component', Header);

interface AppData {
  timer: any // 定时器
}

declare var $: any;

export default Vue.extend({
  name: 'App',
  data(): AppData {
    return {
      timer: null
      // footer: ''
    };
  },
  computed: mapState({
    tableHeader: (state: any) => store.getters.getTableHeader,
    menuIndex: (state: any) => store.getters.getMenuIndex,
    loading: (state: any) => store.getters.getLoading,
    userInfo: (state: any) => store.getters.getUserInfo,
    menuIsCollapse: (state: any) => store.getters.getMenuIsCollapse
  }),
  methods: {
    // 鼠标滚动事件
    handleScroll() {
      // 函数节流
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const scrollTop = (document as any).querySelector('#viewBox').scrollTop;
        // 判断滚动条高度，是否显示固定表头
        if (scrollTop > this.tableHeader.scrollTop) {
          this.$store.dispatch('setTableHeader', {
            isShow: true,
            scrollLeft: $(window).scrollLeft()
          });
        } else {
          this.$store.dispatch('setTableHeader', {
            isShow: false
          });
        }
      }, 0);
    },
    // 初始化signalr
    initSignalR() {
      const connection = new signalR.HubConnectionBuilder()
        .withUrl('/ja/ws/checkHub', {
          transport: signalR.HttpTransportType.LongPolling
        }).build();

      connection.on('Send', (msg: any) => {
        this.$store.dispatch('updateCheckResult', JSON.parse(msg));
      });
      connection.start().catch();
    },
    interceptor() {
      // 请求拦截器
      this.$http.interceptors.request.use(
        (config: any) => {
          if (config.method === 'get') {
            config.params = {
              _t: new Date().getTime(),
              ...config.params
            };
          }
          return config;
        }
      );
      // 响应拦截器
      this.$http.interceptors.response.use(
        (response: any) => {
          if (response && response.status === 200) {
            if (response.request.responseType === 'blob') {
              return response;
            }
            if (response.data.isSucceed || (response.data.captchaResult === false)) {
              return response.data;
            } else {
              if (response.data.message === '您的账户余额不足，请联系管理员充值') {
                this.$alert('您的账户余额不足，请联系管理员充值!', '提示');
              } else if (response.data.message === '交易错误，请稍后重试') {
                this.$alert('交易错误，请稍后重试!', '提示', {
                   confirmButtonText: '确定',
                   callback: () => {
                     if (response.config.url === '/ja/api/Check/Upload/NewCheck') {
                       window.location.reload();
                     }
                    }
                }
                );
              } else {
                if(!!response.data.message){
                  this.$message({
                    message: response.data.message,
                    type: 'error'
                  });
                }else {
                  this.$message({
                    message: '系统错误，请刷新浏览器，或重新打开本页面',
                    type: 'error'
                  });
                }
              }
              return Promise.reject(response.data.message);
            }
          }
          return Promise.reject(response);
        },
        (error: any) => {
          if (error.response) {
            switch (error.response.status) {
              case 401:
                window.location.href = error.response.headers.location;
                break;
            }
          }
        }
      );
    }
  },
  created() {
    this.interceptor();
  },
  watch:{
    userInfo(newVal,oldVal){
      if(this.userInfo.accountType){
        this.$store.dispatch('setCheckHomeUrl');
      }
    }
  },
  mounted() {
    this.initSignalR();
    window.addEventListener('scroll', this.handleScroll);
  }
});
